import { useMemo } from 'react';

import { useBetSlice } from '@pp/core/src/store/slices/bets/selectors';
import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';
import { GameStatus } from '@pp/core/src/store/slices/game/types';

import { useHighflyerStateSlice } from '../../../store/slices/highflyerState/selectors';

import { useIsBetConfirmedConnected } from './useIsBetConfirmedConnected';

export const useIsConfirmButtonDisabled = (betCode: number): boolean => {
  const currentStatus = useGameStateSlice.getCurrentStatus();
  const betLimits = useBetSlice.betLimits() ?? {};
  const betMinLimit = betLimits[betCode].min;
  const isBetConfirmed = useIsBetConfirmedConnected(betCode);
  const remainingBalance = useHighflyerStateSlice.balance();
  const isDealingInProgress = useHighflyerStateSlice.isDealingInProgress(betCode);
  const hasEarlyBets = useHighflyerStateSlice.hasEarlyBets(betCode);

  return useMemo(() => {
    let isDisabled = false;

    const isLowBalance = remainingBalance < betMinLimit;

    if (isLowBalance && !isBetConfirmed) {
      isDisabled = true;
    }
    switch (currentStatus) {
      case GameStatus.BetsClosed:
      case GameStatus.BetsRejected:
      case GameStatus.BetsAccepted:
      case GameStatus.GameCancelled:
        isDisabled = true;
        break;
      case GameStatus.Dealing:
      case GameStatus.WaitForNextGame:
        if (isLowBalance && !isDealingInProgress && !hasEarlyBets) {
          isDisabled = true;
        }
        break;
    }
    return isDisabled;
  }, [currentStatus, betMinLimit, isBetConfirmed, remainingBalance, isDealingInProgress, hasEarlyBets]);
};
